export const DefaultAxisAnimation = {
    type: "default",
    duration: 300,
    easing: "linear"
};
//# sourceMappingURL=config.js.map
